<div class="right-menu-wrapper" [@collapse]="isFilterOpen" *ngIf="showForm">
  <div class="r-menu-content h-100">
    <app-generate-form (formGenerated)="onFormGenerated($event);" [formFields]="genericFormData?.[entityType]">
    </app-generate-form>
  </div>
  <a class="right-filter-icon cursor" (click)="onFilterIconClick()"
    [matBadge]="selectedFilterCount ? selectedFilterCount : null" matBadgePosition="before" matBadgeColor="accent">
    <img src="../../../../assets/images/filter-dropdown-idec.svg" class="h-30" alt="Filter" />
  </a>
</div>